<div [ngClass]="{ 'dropdown-height': !props?.tooltip }" class="drpdown-container" [class]="field.className">
  <h3 *ngIf="!props?.tooltip" class="form-field-title label-style">{{ props.label }}<span *ngIf="props.required">*</span></h3>
    <span *ngIf="props?.tooltip" class="tooltip-label">
        <span class="table-subheading">{{ props.label }}<button
          mat-icon-button class="icon-btn-sm"
          matTooltip="{{ props.tooltip }}"
          color="primary"> <i
            class="fas fa-info-circle text-primary"></i></button>
      </span>
  </span>
  <mat-form-field [appearance]="props.appearance" class="wrapper-class" #form>
    <mat-select
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
      [placeholder]="props.placeholder"
    >
      <mat-option *ngFor="let option of props.options" [value]="option.value">{{
        option.label
      }}</mat-option>
    </mat-select>
    <div
      class="mat-form-field-hint-wrapper"
      [ngClass]="{ 'hint-width': isWidthRequired }"
    >
      <div
        *ngIf="
        showErrMessage(field);
        else (props?.description && hint_field)
        "
      >
        <mat-error>
          <span class="error-message">
            <formly-validation-message
              [field]="field"
            ></formly-validation-message>
          </span>
        </mat-error>
      </div>
      <ng-template #hint_field>
        <div *ngIf="isHtml">
          <mat-hint [innerHtml]="props.description"></mat-hint>
        </div>
        <div *ngIf="!isHtml">
          <mat-hint [innerText]="props.description"></mat-hint>
        </div>
      </ng-template>
    </div>
  </mat-form-field>
</div>